import React, { Component } from 'react';

import { Header, Segment, Container } from 'semantic-ui-react';

export class WhoWeAre extends Component
{
	constructor(props)
	{
		super(props);
	}

	render()
	{
		return (
			<div>
				<Container>
				<Segment basic size='large'>
					<Header size='huge' textAlign={this.props.headerAlign}>
						What You Need to Know About Us
					</Header>
					<p>Our <i>north star</i> at Captivate Games is to create great games that are fun, unique, and engaging. There are a lot of choices when it comes to games. That’s why our vision is to make great games for the long-term. We aren’t interested in squeezing every last dime from you. Not every game we make will be for everyone. Maybe you don’t like our latest game but the next one really resonates. That’s normal. We only want you to spend money when you find value in our games.</p>

					<p>Our role models are companies like Nintendo and Blizzard. We aren’t interested in stealing your information with spyware or selling it to third parties. You are not our product. Games are our products.</p>

					<p>We are a company that treats all stakeholders fairly and with respect. We want to make great games that brings joy to people’s lives. Games are a special medium with the power to make lasting impressions, tell great stories, bring people together, create smiles, and make life better.</p>

					<p><b>That’s why we make games. That’s why we are Captivate Games.</b></p>
				</Segment>
				</Container>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/WhoWeAre.js